import { render } from "./MicroLearningDetails.vue?vue&type=template&id=5e83ce6c&scoped=true"
import script from "./MicroLearningDetails.vue?vue&type=script&lang=js"
export * from "./MicroLearningDetails.vue?vue&type=script&lang=js"

import "./MicroLearningDetails.vue?vue&type=style&index=0&id=5e83ce6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e83ce6c"]])

export default __exports__